export default __webpack_public_path__ + "static/media/Round@3x.5db0bd9a.png";